var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66549 3.6673H0.423828V1.04823C0.423828 0.909282 0.468447 0.77609 0.547769 0.677811C0.627091 0.579596 0.734712 0.524414 0.846878 0.524414H3.66549C3.7569 0.524862 3.84582 0.561564 3.91926 0.629151L5.50043 2.09585L3.91926 3.56256C3.84582 3.63015 3.7569 3.66685 3.66549 3.6673Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.847077 9.95231V3.66654C0.847077 3.37725 0.657671 3.14273 0.424027 3.14273C0.190383 3.14273 0.000976562 3.37725 0.000976562 3.66654V9.95231C0.000976562 10.3863 0.248794 10.6931 0.248794 10.6931C0.496611 10.9999 0.847077 10.9999 0.847077 10.9999H10.1542C10.5046 10.9999 10.7525 10.6931 10.7525 10.6931C11.0003 10.3863 11.0003 9.95231 11.0003 9.95231V2.61892C11.0003 2.18497 10.7525 1.87813 10.7525 1.87813C10.5046 1.57129 10.1542 1.57129 10.1542 1.57129H5.50063C5.26698 1.57129 5.07758 1.80581 5.07758 2.0951C5.07758 2.3844 5.26698 2.61892 5.50063 2.61892H10.1542V9.95231H0.847077Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17094 3.98227C4.17094 3.98227 3.94649 4.18892 3.66683 4.1905L3.66643 4.1905L3.66467 4.19051H0.42305C0.189406 4.19051 0 3.95599 0 3.6667V1.04763C0 1.04763 0 0.613686 0.247817 0.306843C0.247817 0.306843 0.495634 0 0.8461 0L3.66641 4.43348e-06C3.66641 4.43348e-06 3.94632 0.00142971 4.17215 0.209357L5.7533 1.67604C5.78551 1.70591 5.8141 1.74132 5.83823 1.78119C5.9055 1.89237 5.93435 2.03209 5.91842 2.16961C5.90249 2.30713 5.8431 2.43118 5.7533 2.51447L4.17094 3.98227ZM3.66312 3.14288C3.66312 3.14288 3.66475 3.14281 3.66607 3.14159L4.79407 2.09525L3.66485 1.0478C3.66485 1.0478 3.66467 1.04763 3.66293 1.04762L0.8461 1.04763V3.14288H3.66312Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProj);
export default __webpack_public_path__ + "static/media/proj.2774ed8752fdc7ac279aa92ff02d184c.svg";
export { ForwardRef as ReactComponent };